/** A late response may commit only to the mounted event or selection that started it. */
export function feedbackAsyncScope(initialKey: string) {
  let key = initialKey
  let generation = 0
  let mounted = true
  return {
    select(nextKey: string) {
      if (nextKey === key) return
      key = nextKey
      generation += 1
    },
    mount() {
      mounted = true
    },
    unmount() {
      mounted = false
      generation += 1
    },
    isMounted: () => mounted,
    capture() {
      const captured = generation
      return () => mounted && generation === captured
    },
  }
}
